{
  "chooseTimeframe": "Velg periode",
  "loading": "Laster historiske hendelser...",
  "loadingError": "Kunne ikke laste historiske hendelser: {{message}}",
  "showAllTypes": "Vis alle typer",
  "clearChangeTypeFilter": "Fjern typefilter",
  "ownerInfoLabel": "Skogeieropplysninger",
  "shareInfoLabel": "Andelsinformasjon",
  "eventsPerPageLabel": "Hendelser per side",
  "changedBy": "Endret av:",
  "sender": "Avsender",
  "periodFilters": {
    "range": " i valgt periode {{from}} - {{to}}",
    "from": " i valgt periode fra {{from}}",
    "to": " i valgt periode til {{to}}"
  },
  "changeTypes": {
    "contact": "Kontaktopplysninger",
    "address": "Adresseopplysninger",
    "shareHistory": "Andelshistorikk"
  },
  "sms": {
    "allSenders": "Alle avsendere",
    "clearSender": "Fjern avsenderfilter",
    "loading": "Laster SMS-historikk...",
    "loadingError": "Feil ved lasting av SMS-historikk: {{message}}",
    "empty": {
      "title": "Ingen SMS utsendelser funnet",
      "description": "Fant ingen SMS{{filters}}.\nPrøv å justere filterne.",
      "senderFilter": " fra {{sender}}"
    },
    "status": {
      "sent": "Sendt",
      "failed": "Feil under sending",
      "pending": "Sender..."
    },
    "paginationLabel": "SMS-utsendelser per side"
  },
  "emptyStates": {
    "events": {
      "title": "Ingen hendelser funnet",
      "description": "Fant ingen hendelser{{filters}}.\nPrøv å justere filterne.",
      "typeFilter": " på {{type}}"
    }
  }
}
